/** Same-origin relative redirect target only — blocks open redirects. */
export function safeNext(raw: string | null | undefined): string {
  if (!raw) return "/dashboard";
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return "/dashboard";
  return raw;
}

/**
 * The login page's "Create one free" link. 🔴 It must carry the invite token
 * and the invited address along with the return path: a colleague who lands
 * on the invite page, takes "Sign in", finds they have no account and creates
 * one from here used to register as an ordinary user with a personal
 * workspace, and the invite was never bound. The register page already binds
 * the org when it receives `invite_token`.
 */
export function registerHref(opts: { next?: string | null; inviteToken?: string | null; email?: string | null }): string {
  const params = new URLSearchParams();
  if (opts.next && opts.next !== "/dashboard") params.set("next", opts.next);
  if (opts.inviteToken) params.set("invite_token", opts.inviteToken);
  if (opts.email && opts.inviteToken) params.set("email", opts.email);
  const q = params.toString();
  return q ? `/register?${q}` : "/register";
}
